@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.progress {
}

.spinner {
	--fill-color: var(--lp-color-gray-500);
	display: inline-flex;
}

.bar {
	--fill-color: var(--lp-color-brand-cyan-base);
	display: grid;
	grid-template-areas:
		'label value'
		'bar bar';
	grid-template-columns: 1fr auto;
	gap: var(--lp-spacing-300);
}

.outerCircle {
	stroke: var(--lp-color-white-100);
}

.innerCircle {
	stroke: var(--fill-color);
}

.value {
	grid-area: value;
	font: var(--lp-text-label-1-medium);
}

.track {
	grid-area: bar;
	height: var(--lp-size-10);
	border-radius: var(--lp-border-radius-medium);
	background-color: var(--lp-color-bg-ui-tertiary);
}

.fill {
	border-top-left-radius: var(--lp-border-radius-medium);
	border-bottom-left-radius: var(--lp-border-radius-medium);
	background-color: var(--fill-color);
	height: 100%;
}

.max {
	border-radius: var(--lp-border-radius-medium);
}

.base {
	height: var(--lp-size-64);
	width: var(--lp-size-64);
}

.small {
	height: var(--lp-size-16);
	width: var(--lp-size-16);
}

.medium {
	height: var(--lp-size-24);
	width: var(--lp-size-24);
}

.large {
	height: var(--lp-size-32);
	width: var(--lp-size-32);
}

@media (prefers-reduced-motion: no-preference) {
	.indeterminate {
		animation-name: spin;
		animation-duration: var(--lp-duration-350);
		animation-timing-function: linear;
		animation-iteration-count: infinite;
	}
}
